declare const __KREBIT_OAUTH_CLIENT_ID__: string;
declare const __KREBIT_APP_BASE_URL__: string;
declare const __KREBIT_DEV_MODE__: boolean;

const trimTrailingSlash = (value: string) => value.replace(/\/+$/, "");

export const config = {
  oauthClientId: __KREBIT_OAUTH_CLIENT_ID__,
  appBaseUrl: trimTrailingSlash(__KREBIT_APP_BASE_URL__),
  devMode: __KREBIT_DEV_MODE__,
  maxPdfBytes: 10 * 1024 * 1024,
};

export function getRedirectUri(): string {
  return `${config.appBaseUrl}/auth/callback.html`;
}

export function getTenantBaseUrl(tenant: string): string {
  return `https://${tenant}.krebit.se`;
}
